module.exports = __webpack_public_path__ + "media/components/country-flag/static/dj-96f13ea2f32a919725b02391b1cec604.svg";